import React from 'react'

import Heading from '../Heading'
import { ExportHeadingProps } from '../Heading/types'

const HeadingLarge: React.FC<ExportHeadingProps> = ({ Tag = 'h2', children, ...props }) => (
  <Heading Tag={Tag} size="large" {...props}>
    {children}
  </Heading>
)
export default HeadingLarge
